export default __webpack_public_path__ + "static/media/Girls_On_Fire.0289da94.png";